import { Actions, Button } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import type { TranslationKeys } from '@vocab/core';

import translations from './.vocab';

type TranslateFn = ReturnType<typeof useTranslations>['t'];
export type ActionButtonsTranslationKey = TranslationKeys<typeof translations>;
export type ActionButtonsMessageTranslations = Pick<
  Record<ActionButtonsTranslationKey, string>,
  'Add Candidate' | 'Continue' | 'Cancel'
>;
export const translationMessages = (
  t: TranslateFn,
): ActionButtonsMessageTranslations => ({
  'Add Candidate': t('Add Candidate'),
  Continue: t('Continue'),
  Cancel: t('Cancel'),
});

interface Props {
  buttonText: ActionButtonsTranslationKey;
  handleCancel: () => void;
  isLoading: boolean;
}
const ActionButtons = ({ buttonText, isLoading, handleCancel }: Props) => {
  const { t } = useTranslations(translations);
  const messages = translationMessages(t);
  return (
    <Actions>
      <Button loading={isLoading} type="submit">
        {messages[buttonText]}
      </Button>
      <Button onClick={handleCancel} variant="transparent" tone="neutral">
        {t('Cancel')}
      </Button>
    </Actions>
  );
};

export default ActionButtons;
